import React, { useEffect, useState } from 'react'
import { BaseLayout } from 'src/layouts'
import styles from './styles.module.scss'
import { Header } from './components/Header'
import { Filter } from './components/Filter'
import { List } from './components/List'
import { useReview } from 'src/state'
import { WEBSITE } from 'src/consts'
import { splitContentByPageBreak } from 'src/utils/content'
import { useReviewContent } from 'src/state'
import { Container } from 'src/elements'

const formatReview = data => {
  const itemParse = {}
  if (!!data) {
    data.forEach(item => {
      const obj = item.attributes
      if (obj?.reviews?.data) {
        itemParse[obj.title] = obj.reviews.data.map(review => ({
          title: review.attributes.title,
          shortPreview: review.attributes.shortPreview,
          content: review.attributes.content,
          slug: review.attributes.slug,
          teaser: review.attributes.teaser,
          thumbnail: review.attributes.thumbnail?.data?.attributes?.url,
          author: review.attributes.author,
          image: item.attributes.image?.data?.attributes?.url,
          category: item.attributes.title,
          rating: review.attributes.ratings.data.map(rating => ({
            name: rating.attributes.ratingAttribute.data.attributes.name,
            score: rating.attributes.score,
            show: rating.attributes.show,
          })),
        }))
      }
    })
  }

  return { data: itemParse }
}

export const Review = () => {
  const reviewData = formatReview(useReview().data)
  const keys = Object.keys(reviewData.data)
  const [itemActive, setItemActive] = useState('')
  const [dataFilter, setDataFilter] = useState(reviewData.data)
  const [search, setSearch] = useState('')
  const reviewContent = useReviewContent()
  const contentSegments = splitContentByPageBreak(reviewContent.data || '')

  useEffect(() => {
    if (search) {
      const dataFilter = keys.reduce((acc, key) => {
        const data = reviewData.data[key].filter(item => {
          return item.title.toLowerCase().includes(search.toLowerCase())
        })
        return { ...acc, [key]: data }
      }, {})

      setDataFilter(
        Object.entries(dataFilter)
          .filter(([key, value]) => value)
          .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {})
      )
    } else {
      setDataFilter(reviewData.data)
    }
  }, [search])

  useEffect(() => {
    if (itemActive === '') {
      setDataFilter(reviewData.data)
    } else {
      const newData = reviewData.data[itemActive]
      setDataFilter({ [itemActive]: newData })
      setSearch('')
    }
  }, [itemActive])

  const title = 'In-Depth Crypto Platform Reviews & Analysis | COIN360'
  const description =
    'Coin360 offers thorough, in-depth reviews on the latest in crypto and digital services. Explore the online world with clarity and confidence, backed by our detailed insights.'
  const uri = `review`

  const reviewSchema = {
    '@type': 'ItemList',
    name: title,
    description: description,
    itemListElement: [],
  }

  Object.keys(reviewData.data).forEach((key, index) => {
    reviewData.data[key].forEach(item => {
      reviewSchema.itemListElement.push({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Thing',
          name: item.title,
          description: item.shortPreview,
          url: `${WEBSITE}/review/${item.slug}`,
        },
      })
      index++
    })
  })

  return (
    <BaseLayout
      scrollInContent
      seo={{
        title: title,
        description: description,
        canonical: `${WEBSITE}/${uri}`,
        jsonLd: reviewSchema as any,
      }}
    >
      <div className={styles.container}>
        <Header />
        <Filter
          keys={keys}
          itemActive={itemActive}
          setItemActive={setItemActive}
          search={search}
          setSearch={setSearch}
        />
        <div className={styles.mainContent}>
          <List data={dataFilter} />
        </div>
        <Container className={styles.contentContainer}>
          {contentSegments.map((segment, index) => (
            <div
              key={index}
              className={`
      ${index === 0 ? styles.firstContent : styles.otherContent} 
      ${index === contentSegments.length - 1 ? styles.lastContent : ''}
    `}
            >
              <div dangerouslySetInnerHTML={{ __html: segment }} />
            </div>
          ))}
        </Container>
      </div>
    </BaseLayout>
  )
}
